import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function listCompanyByContact(contact_id) {
  const path = `crm/companies/list_to_select_by_contact/${contact_id}`;
  const company = await laravelAxios.get(path);
  return company;
}

export default listCompanyByContact;